import ReactMarkdown from 'react-markdown'

import remarkGfm from 'remark-gfm'

import {
  CWTable,
  CWTableHeadCell,
  CWTableBodyRow,
  CWTableBodyCell,
  CWTableHead,
  CWTableBody,
} from '../ComponentsWeb/Table'
import { TextLink } from '../TextLink'
import { UnorderedList } from '../UnorderedList'

import type { Components } from 'react-markdown/lib'

/**
 * Props for the MarkdownRenderer component.
 */
export type MarkdownRendererProps = {
  /**
   * Additional classes.
   */
  className?: string

  /**
   * Markdown string.
   */
  markdown?: string | null
}

/**
 * Component that receives markdown as a prop and renders html.
 */
export const MarkdownRenderer = ({
  markdown,
  className,
}: MarkdownRendererProps) => {
  const components = {
    table: CWTable,
    th: CWTableHeadCell,
    tr: CWTableBodyRow,
    td: CWTableBodyCell,
    thead: CWTableHead,
    tbody: CWTableBody,
    ul: UnorderedList,
    a: (props) => <TextLink {...props} variant="primary" />,
    code: (props) => <code className="whitespace-pre-wrap" {...props} />,
  } as Components

  return (
    <div className={className}>
      <ReactMarkdown components={components} remarkPlugins={[remarkGfm]}>
        {markdown}
      </ReactMarkdown>
    </div>
  )
}
